import {components} from "react-select";
import Checkbox from "../../../../../core/Checkbox/Checkbox";

const Option = (props) => {
    return (
        <div className="option-item">
            <components.Option {...props}>
                <div className='label'> {props.label}</div>
                    <Checkbox checked={props.isSelected}/>
            </components.Option>
        </div>
);
};
export default Option
